import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './localization/en.json';

/**
 * The app ships a single bundled locale, so there is no backend or language
 * detector here; enterprise-manager-frontend loads its namespaces over XHR
 * because it serves several locales from /locales.
 */
void i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  resources: {
    en: { translation: en },
  },
  // React escapes rendered text already, and the strings contain markup
  // placeholders such as <link> that must survive interpolation.
  interpolation: { escapeValue: false },
});

export default i18n;
